import { render, staticRenderFns } from "./ExportDistribution.vue?vue&type=template&id=21dff016&"
import script from "./ExportDistribution.vue?vue&type=script&lang=js&"
export * from "./ExportDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports